import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../app/routes";
import DataTable from "react-data-table-component";
import CreateButton from "./CreateButton";
import { Modal } from "react-bootstrap";
import Form from "./Form";

export default function Table() {
  const [collection, setCollection] = useState();
  const [loaded, setLoaded] = useState(false);

  const [filteredCoach, setFilteredCoach] = useState("");
  const [filteredStudent, setFilteredStudent] = useState("");

  const [coachName, setCoachName] = useState("");
  const [memberName, setMemberName] = useState("");
  const [programName, setProgramName] = useState("");
  const [programId, setProgramId] = useState("");
  const [workType, setWorkType] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [formStudentId, setFormStudentId] = useState("");
  const [formSuggestCoachId, setFormSuggestCoachId] = useState("");
  const [formChangeCoachRequestId, setFormChangeCoachRequestId] = useState("");
  const [formStatus, setFormStatus] = useState("");

  const [show, setShow] = useState(false);

  const closeForm = () => setShow(false);
  const openForm = () => setShow(true);

  const editChangeCoach = (id) => {
    axios.get(routes.api.change_coach_requests.show(id)).then((resp) => {
      const formData = resp.data.data.attributes;
      setCoachName(formData.coach_name);
      setMemberName(formData.student_name);
      setProgramName(formData.program_name);
      setWorkType(formData.type_work);
      setFormDescription(formData.description);
      setFormStudentId(formData.student_id);
      setFormSuggestCoachId(formData.new_coach_id);
      setFormChangeCoachRequestId(formData.id);
      setProgramId(formData.program_id);
      setFormStatus(formData.status);
      openForm();
    });
  };

  const declineChange = (id) => {
    swal(
      {
        title: "",
        text: "Do you want to deny this request?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Deny",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          axios
            .get(routes.api.change_coach_requests.decline(id))
            .then((resp) => {
              updateCollection();
            });
        }
      }
    );
  };

  const approveChange = (id) => {
    swal(
      {
        title: "",
        text: "Do you want to approve this request?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Approve",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          axios
            .get(routes.api.change_coach_requests.accept(id))
            .then((resp) => {
              updateCollection();
            });
        }
      }
    );
  };

  const filteredItems =
    collection &&
    Object.values(collection).filter((item) => {
      let available = true;

      if (
        !(
          item.attributes.coach_name
            .toLowerCase()
            .includes(filteredCoach.toLowerCase()) &&
          item.attributes.student_name
            .toLowerCase()
            .includes(filteredStudent.toLowerCase())
        )
      )
        available = false;

      return available;
    });

  const columns = [
    {
      name: "Date Created",
      selector: "attributes.format_created_at",
      sortable: true,
      sortFunction: (a, b) =>
        a.attributes.created_at_int - b.attributes.created_at_int,
    },
    {
      name: "Created By",
      selector: "attributes.created_by",
      sortable: true,
    },
    {
      name: "Coach Name",
      selector: "attributes.coach_name",
      sortable: true,
    },
    {
      name: "Member Name",
      selector: "attributes.student_name",
      sortable: true,
    },
    {
      name: "Completed Sessions",
      selector: "attributes.program_start",
      sortable: true,
    },
    {
      name: "Status",
      selector: "attributes.human_status",
      sortable: true,
    },
    {
      name: "Timestamp",
      selector: "attributes.format_timestamp",
      sortable: false,
    },
    {
      name: "Actions",
      width: "200px",
      cell: (row) => (
        <div>
          <a
            onClick={() => approveChange(row.id)}
            className={`btn ${
              row.attributes.human_status === "Waiting" ||
              row.attributes.status === "accepted" ||
              row.attributes.status === "declined" ||
              row.attributes.status === "completed"
                ? "btn-gray disabled"
                : "btn-primary"
            } mr5`}
          >
            <i className="fa fa-fw fa-play-circle"></i>
          </a>
          <a
            onClick={() => editChangeCoach(row.id)}
            className="btn btn-primary mr5"
          >
            <i className="fa fa-fw fa-edit"></i>
          </a>
          <a
            onClick={() => declineChange(row.id)}
            className={`btn ${
              row.attributes.status === "accepted" ||
              row.attributes.status === "declined" ||
              row.attributes.status === "completed"
                ? "btn-gray disabled"
                : "btn-danger"
            } mr5`}
          >
            <i className="fa fa-fw fa-trash"></i>
          </a>
        </div>
      ),
      sortable: false,
    },
  ];

  const updateCollection = () => {
    setLoaded(true);
    axios.get(routes.api.change_coach_requests.list).then((resp) => {
      setCollection(resp.data.data);
      setLoaded(false);
    });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="COACH NAME"
            value={filteredCoach}
            onChange={(e) => setFilteredCoach(e.target.value)}
          />
        </div>
        <div class="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="MEMBER NAME"
            value={filteredStudent}
            onChange={(e) => setFilteredStudent(e.target.value)}
          />
        </div>
        <div class="col-md-4">
          <CreateButton
            workType="AdminChangeMember"
            buttonName="Member Request"
            className="btn btn-green ml10"
            updateCollection={updateCollection}
          />
          <CreateButton
            workType="AdminChangeCoach"
            buttonName="Coach Request"
            className="btn btn-green ml10"
            updateCollection={updateCollection}
          />
        </div>
      </div>
      {loaded && <p className="text-center mt20">Processing...</p>}
      {!loaded && (
        <DataTable
          title=""
          columns={columns}
          data={filteredItems}
          noDataComponent="No matching records found"
          persistTableHead={true}
        />
      )}
      <Modal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>Coach Change Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            closeForm={closeForm}
            coachName={coachName}
            memberName={memberName}
            programName={programName}
            programId={programId}
            workType={workType}
            updateCollection={updateCollection}
            formDescription={formDescription}
            formStudentId={formStudentId}
            formSuggestCoachId={formSuggestCoachId}
            formChangeCoachRequestId={formChangeCoachRequestId}
            formStatus={formStatus}
            workMode="edit"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
